import React from 'react';
import Img from 'shared/img';
import styles from './stickies.module.scss';

function StickyImg({ img, mobile, tablet }) {
  return (
    <Img
      src={img || 'placeholder-dark'}
      className={`${styles.stickyImg} ${mobile ? styles.mobile : ''} ${tablet ? styles.tablet : ''}`}
    />
  );
}
export default StickyImg;
